module.exports = __webpack_public_path__ + "img/eye.b1663886.svg";